:host .event-list-item-container {
  --aha-event-list-item--time-width: calc(var(--spacer) * 18);
  --aha-event-list-item--top: var(--spacer-2);
  --aha-event-list-item--bottom: var(--spacer-2);
  --aha-event-list-item--line-width: var(--spacer-05);
  --aha-event-list-item--line-color: var(--theme-primary-border);
  --aha-event-list-item--line-visibility: visible;
  --aha-event-list-item--hover-background: var(--theme-list-item-hover-background	);

  margin-top: var(--spacer-05);
  margin-bottom: var(--spacer-05);
  display: grid;
  grid-template-columns:
    var(--aha-event-list-item--time-width) var(--aha-event-list-item--line-width)
    auto;
  grid-template-rows: auto;
  column-gap: var(--spacer-3);
  position: relative;
  color: var(--theme-primary-text);
}
:host .event-list-item-container:hover {
  background-color: var(--aha-event-list-item--hover-background);
}
:host,
:host * {
  box-sizing: border-box;
}
:host .time {
  white-space: nowrap;
  display: flex;
  justify-content: flex-end;
  padding-top: var(--aha-event-list-item--top);
}
:host .line {
  margin: var(--spacer-05) 0;
  background: var(--aha-event-list-item--line-color);
  width: var(--aha-event-list-item--line-width);
}

:host #content {
  padding-top: var(--aha-event-list-item--top);
  padding-bottom: var(--aha-event-list-item--bottom);
  font-size: 0.875rem;
}

:host #content ::slotted(:last-child) {
  /* override the margin-bottom of the last child to stop it adding spacing at the bottom of the item */
  margin-bottom: 0 !important;
}
